// Make all event listeners passive by default
(function() {
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
  const passiveEvents = ['touchstart', 'touchmove', 'wheel', 'mousewheel'];

  EventTarget.prototype.addEventListener = function(type, listener, options) {
    let newOptions = options;
    
    // Convert boolean to object if necessary
    if (typeof options === 'boolean') {
      newOptions = {
        capture: options,
        passive: passiveEvents.includes(type)
      };
    } else if (typeof options === 'object') {
      newOptions = {
        ...options,
        passive: options.passive === undefined && passiveEvents.includes(type) ? true : options.passive
      };
    } else {
      newOptions = {
        passive: passiveEvents.includes(type)
      };
    }
    
    return originalAddEventListener.call(this, type, listener, newOptions);
  };

  EventTarget.prototype.removeEventListener = function(type, listener, options) {
    return originalRemoveEventListener.call(this, type, listener, options);
  };
})();
